// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2btjY","top":"styles_top__2cpSu","left":"styles_left__2X2pe","description":"styles_description__2vlEl"};